export const TAMANHO_MAXIMO_FOTO_PERFIL = 2 * 1024 * 1024;
export const TIPOS_FOTO_PERFIL = ["image/jpeg", "image/png", "image/webp"];

export function urlFotoPerfilValida(valor: string) {
  if (!valor || valor.length > 2048) return false;
  try {
    const url = new URL(valor);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function urlFotoPerfilEnviadaPeloUsuario(valor: string, usuarioId: string) {
  if (!urlFotoPerfilValida(valor)) return false;
  const url = new URL(valor);
  const hostsSupabase = (process.env.NEXT_PUBLIC_STORAGE_ALLOWED_HOSTS ?? "")
    .split(",")
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);
  const pathname = `/perfis/${encodeURIComponent(usuarioId)}/avatar`;
  const supabase = url.hostname.endsWith(".supabase.co") && url.pathname.includes("/storage/v1/s3/");
  return url.protocol === "https:"
    && (
      hostsSupabase.includes(url.hostname.toLowerCase())
      || supabase
    )
    && (url.pathname === pathname || (supabase && url.pathname.endsWith(pathname)));
}
